<template>
  <div class="error-dialog-area">
    <el-dialog
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="error-dialog"
    >
      <div class="error-dialog-content cursor-pointer" @click="handleClose">
        <div class="error-body">
          <div class="error-icon" @click="handleClose">
            <div class="error-circle">
              <div class="error-x">✕</div>
            </div>
          </div>
          <div class="error-content-wrapper">
            <div class="error-header">
              <div class="error-badge">{{ $t('error') }}</div>
            </div>
            <div class="error-message">
              <p>{{ $t('reading_error1') }}</p>
              <p>{{ $t('reading_error2') }}</p>
              <p>{{ $t('reading_error3') }}</p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ErrorDialog',
  emits: ['update:modelValue'],
})
export default class ErrorDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  modelValue!: boolean

  handleClose() {
    this.$emit('update:modelValue', false)
  }
}
</script>

<style lang="scss">
.error-dialog-area {
  .el-dialog {
    margin-top: 0px !important;
    padding: 0;
    border-radius: 0;
    max-width: 1000px !important;
    width: 1000px !important;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .error-dialog-content {
    background: #ff0000;
    font-family: sans-serif;
    position: relative;
  }

  .error-header {
    padding: 20px;
  }

  .error-content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .error-badge {
    background: #ffff00;
    color: #ff0000;
    font-size: 48px;
    font-weight: bold;
    padding: 15px 80px;
    box-shadow: inset 0 2px 0 rgba(255, 255, 255, 0.3), 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .error-body {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 40px 80px;
    gap: 60px;
  }

  .error-icon {
    flex-shrink: 0;
  }

  .error-circle {
    width: 310px;
    height: 310px;
    border-radius: 50%;
    background: linear-gradient(145deg, #cc0000 0%, #990000 100%);
    border: 15px solid #c0c0c0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5), inset 0 -5px 15px rgba(0, 0, 0, 0.3);
    position: relative;
  }

  .error-x {
    color: #c0c0c0;
    font-size: 180px;
    font-weight: bold;
    text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5), -2px -2px 4px rgba(255, 255, 255, 0.1);
    line-height: 1;
    font-family: Arial, sans-serif;
  }

  .error-message {
    text-align: left;

    p {
      color: #ffffff;
      font-size: 64px;
      font-weight: bold;
      margin: 0;
      line-height: 1.3;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
